
var ViewFactory = require('tplify/dist/viewFactory').default;

delete module.exports;

var viewFactory = new ViewFactory('<div class="packagePresenter-wrapper">\r\n\t<span class="packagePresenter-licencePlate" data-property="licencePlate"></span>\r\n\t<span class="packagePresenter-grossWeight"><span data-translate="grossWeight">Gross Weight</span><span>: </span><span data-property="grossWeight"></span></span>\r\n\t<span class="packagePresenter-volume"><span data-translate="volume">Volume</span><span>: </span><span data-property="volume"></span></span>\r\n\t<span class="packagePresenter-volume"><span data-translate="packagegoodsItemDescription">Varebeskrivelse</span><span>: </span><span data-property="goodsItemDescription"></span></span>\r\n</div>\r\n');

Object.defineProperty(module, 'exports', {
get: function() {
    return viewFactory.create();
}
});
